// Mock data for the real estate application

export interface Property {
  id: string;
  title: string;
  price: number;
  location: string;
  area: number; // in square meters
  bedrooms: number;
  bathrooms: number;
  garages: number;
  floor: number;
  type: 'sale' | 'rent';
  category: string;
  categoryId: string;
  description: string;
  mainImage: string;
  galleryImages: string[];
  videoUrl?: string;
  mapsUrl?: string;
  adminNote?: string;
  featured: boolean;
  active: boolean; // true = visible on website, false = hidden (sold)
  facilities: string[];
  nearby: string[];
  coordinates?: { lat: number; lng: number };
  createdAt: string;
}

export interface Category {
  id: string;
  name: string;
  nameEn: string;
  icon: string;
  count: number;
}

export interface Facility {
  id: string;
  name: string;
  nameEn: string;
  icon: string;
}

export interface NearbyPlace {
  id: string;
  name: string;
  nameEn: string;
  icon: string;
}

export const categories: Category[] = [
  { id: '1', name: 'شقق', nameEn: 'Apartments', icon: 'Building2', count: 32 },
  { id: '2', name: 'فلل', nameEn: 'Villas', icon: 'Home', count: 22 },
  { id: '3', name: 'مكاتب', nameEn: 'Offices', icon: 'Briefcase', count: 15 },
  { id: '4', name: 'محلات تجارية', nameEn: 'Commercial', icon: 'Store', count: 18 },
  { id: '5', name: 'بنغل', nameEn: 'Bungalow', icon: 'House', count: 8 },
];

export const facilities: Facility[] = [
  { id: '1', name: 'مصعد', nameEn: 'elevator', icon: 'ArrowUpDown' },
  { id: '2', name: 'جراج', nameEn: 'garage', icon: 'CarFront' },
  { id: '3', name: 'أمن', nameEn: 'security', icon: 'Shield' },
  { id: '4', name: 'مسبح', nameEn: 'pool', icon: 'Waves' },
  { id: '5', name: 'حديقة', nameEn: 'garden', icon: 'Trees' },
  { id: '6', name: 'مكيف', nameEn: 'ac', icon: 'Wind' },
  { id: '7', name: 'تدفئة مركزية', nameEn: 'heating', icon: 'Flame' },
  { id: '8', name: 'إنترنت', nameEn: 'internet', icon: 'Wifi' },
];

export const nearbyPlaces: NearbyPlace[] = [
  { id: '1', name: 'مدارس', nameEn: 'schools', icon: 'GraduationCap' },
  { id: '2', name: 'مستشفيات', nameEn: 'hospitals', icon: 'Hospital' },
  { id: '3', name: 'مواصلات', nameEn: 'transportation', icon: 'Bus' },
  { id: '4', name: 'مولات', nameEn: 'malls', icon: 'ShoppingBag' },
  { id: '5', name: 'مطاعم', nameEn: 'restaurants', icon: 'UtensilsCrossed' },
  { id: '6', name: 'مساجد', nameEn: 'mosques', icon: 'Building' },
];

export const properties: Property[] = [
  {
    id: '1',
    title: 'شقة فاخرة للعائلات في التجمع الخامس',
    price: 3500000,
    location: 'التجمع الخامس، القاهرة الجديدة',
    area: 250,
    bedrooms: 4,
    bathrooms: 3,
    garages: 2,
    floor: 3,
    type: 'sale',
    category: 'شقق',
    categoryId: '1',
    description: 'شقة فاخرة مع إطلالة رائعة على المدينة. تتميز بتصميم عصري وتشطيبات راقية. تقع في موقع حيوي قريب من جميع الخدمات والمرافق الأساسية. مساحات واسعة ومريحة مع إضاءة طبيعية ممتازة.',
    mainImage: 'https://images.unsplash.com/photo-1638454668466-e8dbd5462f20?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwxfHx8fDE3NzI1NTA0MDJ8MA&ixlib=rb-4.1.0&q=80&w=1080',
    galleryImages: [],
    featured: true,
    active: true,
    facilities: ['1', '2', '3', '6', '8'],
    nearby: ['1', '2', '3', '4'],
    coordinates: { lat: 30.0131, lng: 31.4348 },
    createdAt: '2026-03-01',
  },
  {
    id: '2',
    title: 'فيلا عائلية في الساحل الشمالي',
    price: 8500000,
    location: 'الساحل الشمالي، مطروح',
    area: 350,
    bedrooms: 5,
    bathrooms: 4,
    garages: 3,
    floor: 1,
    type: 'sale',
    category: 'فلل',
    categoryId: '2',
    description: 'فيلا رائعة مع حديقة خاصة ومسبح. تصميم معماري فريد يجمع بين الأصالة والحداثة. موقع هادئ ومميز في منطقة راقية. مساحات خضراء واسعة ومرافق متكاملة. إطلالة مباشرة على البحر.',
    mainImage: 'https://images.unsplash.com/photo-1757439402115-c3c496fe81ec?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB2aWxsYSUyMGV4dGVyaW9yJTIwcG9vbHxlbnwxfHx8fDE3NzI1NjI0MjV8MA&ixlib=rb-4.1.0&q=80&w=1080',
    galleryImages: [],
    featured: true,
    active: true,
    facilities: ['2', '3', '4', '5', '6', '7', '8'],
    nearby: ['1', '2', '4', '6'],
    coordinates: { lat: 30.8258, lng: 28.7451 },
    createdAt: '2026-02-28',
  },
  {
    id: '3',
    title: 'شقة عصرية بإطلالة على النيل',
    price: 15000,
    location: 'المعادي، القاهرة',
    area: 200,
    bedrooms: 3,
    bathrooms: 2,
    garages: 2,
    floor: 5,
    type: 'rent',
    category: 'شقق',
    categoryId: '1',
    description: 'شقة عصرية مع إطلالة بانورامية على نهر النيل. تشطيبات فاخرة ومرافق حديثة. موقع استراتيجي قريب من المراكز التجارية والخدمات. منطقة راقية وحيوية.',
    mainImage: 'https://images.unsplash.com/photo-1761679297197-91478b218201?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb25kbyUyMG1vdW50YWluJTIwdmlld3xlbnwxfHx8fDE3NzI2MTMyODB8MA&ixlib=rb-4.1.0&q=80&w=1080',
    galleryImages: [],
    featured: true,
    active: true,
    facilities: ['1', '2', '3', '6', '8'],
    nearby: ['1', '2', '3', '4', '5'],
    coordinates: { lat: 29.9600, lng: 31.2632 },
    createdAt: '2026-02-27',
  },
  {
    id: '4',
    title: 'مكتب تجاري في برج حديث بالقاهرة',
    price: 8000,
    location: 'مدينة نصر، القاهرة',
    area: 150,
    bedrooms: 0,
    bathrooms: 2,
    garages: 1,
    floor: 10,
    type: 'rent',
    category: 'مكاتب',
    categoryId: '3',
    description: 'مكتب واسع في برج تجاري حديث. مجهز بالكامل بأحدث التقنيات. موقع مميز في قلب المدينة التجاري. قريب من الطرق الرئيسية ومحطات المترو.',
    mainImage: 'https://images.unsplash.com/photo-1703355685639-d558d1b0f63e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGludGVyaW9yfGVufDF8fHx8MTc3MjU4OTgxM3ww&ixlib=rb-4.1.0&q=80&w=1080',
    galleryImages: [],
    featured: false,
    active: true,
    facilities: ['1', '3', '6', '8'],
    nearby: ['2', '3', '4', '5'],
    coordinates: { lat: 30.0626, lng: 31.3462 },
    createdAt: '2026-02-26',
  },
  {
    id: '5',
    title: 'محل تجاري في موقع استراتيجي بالإسكندرية',
    price: 2500000,
    location: 'سموحة، الإسكندرية',
    area: 120,
    bedrooms: 0,
    bathrooms: 1,
    garages: 0,
    floor: 1,
    type: 'sale',
    category: 'محلات تجارية',
    categoryId: '4',
    description: 'محل تجاري واسع على شارع رئيسي. مساحة مفتوحة قابلة للتخصيص حسب النشاط. موقع حيوي مع حركة مرور عالية. مناسب لجميع الأنشطة التجارية.',
    mainImage: 'https://images.unsplash.com/photo-1761333477936-56fbc7851c65?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwcmV0YWlsJTIwc3RvcmV8ZW58MXx8fHwxNzcyNTE0NjE1fDA&ixlib=rb-4.1.0&q=80&w=1080',
    galleryImages: [],
    videoUrl: 'https://www.youtube.com/watch?v=LXb3EKWsInQ',
    featured: false,
    active: true,
    facilities: ['3', '6', '8'],
    nearby: ['3', '4', '5'],
    coordinates: { lat: 31.2156, lng: 29.9553 },
    createdAt: '2026-02-25',
  },
  {
    id: '6',
    title: 'بنغل فاخر مع حديقة في 6 أكتوبر',
    price: 4500000,
    location: 'الشيخ زايد، 6 أكتوبر',
    area: 280,
    bedrooms: 4,
    bathrooms: 3,
    garages: 2,
    floor: 1,
    type: 'sale',
    category: 'بنغل',
    categoryId: '5',
    description: 'بنغل واسع مع تصميم عصري وحديقة واسعة. مثالي للعائلات الكبيرة. في منطقة هادئة وآمنة. قريب من جميع الخدمات والمدارس الدولية.',
    mainImage: 'https://images.unsplash.com/photo-1743813584899-696881ddc8aa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidW5nYWxvdyUyMGhvdXNlJTIwZXh0ZXJpb3IlMjBnYXJkZW58ZW58MXx8fHwxNzcyNjEzMjc5fDA&ixlib=rb-4.1.0&q=80&w=1080',
    galleryImages: [],
    featured: false,
    active: true,
    facilities: ['2', '3', '5', '6', '7', '8'],
    nearby: ['1', '2', '3', '6'],
    coordinates: { lat: 30.0218, lng: 30.9746 },
    createdAt: '2026-02-24',
  },
];